<template>
  <div class="home-page">
    <page_head class="page-top"></page_head>
    <div class="page-content">
      <left_bar></left_bar>
      <div class="right-content">
        <router-view></router-view>
      </div>
    </div>
    <loading></loading>
  </div>
</template>

<script>
  import ChartMap from '@/view/map'
  import LeftBar from '../components/LeftBar'
  import PageHead from '../components/PageHead'
  import SwitchMapBtn from '../components_bit/SwitchMapBtn'
  import Loading from '../components_bit/Loading'
  export default {
    components: {
      left_bar: LeftBar,
      page_head: PageHead,
      switch_map_btn: SwitchMapBtn,
      chart_map: ChartMap,
      loading: Loading
    },
    created () {
      this.$store.dispatch('getCaseList')
      if (this.solutionStatus === 0 && this.$router.history.current.name === 'home_base') {
        this.$router.push({name: 'import'})
      }
    },
    computed: {
      solutionStatus: {
        get () {
          return this.$store.getters.solutionStatus
        }
      },
      path: {
        get () {
          return this.$store.state.route.path
        }
      }
    }
  }
</script>

<style scoped lang="less">
  @import '../style/base.less';
  .page-top {
    z-index: 4;
  }
  .right-content::-webkit-scrollbar {
    display: none;
  }
</style>



// WEBPACK FOOTER //
// home_base.vue?cbe47738